/**
 * LoginDialog 归因上下文（匿名限制漏斗）。
 * LoginDialog 打开时优先读 reward 上下文，否则读本上下文。
 */
export function useAnonGateAnalyticsContext() {
  const authContext = useState('anon-gate-analytics-auth-context', () => null)

  function setAuthContext({ from = '', triggerType = 'click' } = {}) {
    authContext.value = from
      ? {
          from: String(from),
          trigger_type: triggerType === 'pop' ? 'pop' : 'click',
        }
      : null
  }

  function clearAuthContext() {
    authContext.value = null
  }

  return { authContext, setAuthContext, clearAuthContext }
}
